<template>
  <div class="business">
    <div class="ani logo" swiper-animate-effect="fadeIn" swiper-animate-duration="0.5s">
      <a href="#home">
        <img src="../assets/logo2.png">
      </a>
    </div>
    <div class="business-con">
      <div
        class="business-title ani"
        swiper-animate-effect="fadeInUp"
        swiper-animate-duration="1.5s"
      >
        <h2>Business</h2>
      </div>
      <div class="business-swiper">
        <div class="swiper-container business-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <img
                class="ani"
                swiper-animate-effect="fadeInUp"
                swiper-animate-duration="1s"
                swiper-animate-delay="0.2s"
                src="../assets/1.jpg"
              >
              <div
                class="ani"
                swiper-animate-effect="fadeInUp"
                swiper-animate-duration="1s"
                swiper-animate-delay="0.4s"
              >
                <h4>Ocean freight service of FCL/LCL</h4>
              </div>
            </div>
            <div class="swiper-slide">
              <img
                class="ani"
                swiper-animate-effect="fadeInUp"
                swiper-animate-duration="1s"
                swiper-animate-delay="0.6s"
                src="../assets/2.jpg"
              >
              <div
                class="ani"
                swiper-animate-effect="fadeInUp"
                swiper-animate-duration="1s"
                swiper-animate-delay="0.8s"
              >
                <h4>Air freight service</h4>
              </div>
            </div>
            <div class="swiper-slide">
              <img
                class="ani"
                swiper-animate-effect="fadeInUp"
                swiper-animate-duration="1s"
                swiper-animate-delay="0.9s"
                src="../assets/3.jpg"
              >
              <div
                class="ani"
                swiper-animate-effect="fadeInUp"
                swiper-animate-duration="1s"
                swiper-animate-delay="1.2s"
              >
                <h4>Warehouse & Supply chain</h4>
              </div>
            </div>
            <div class="swiper-slide">
              <img
                class="ani"
                swiper-animate-effect="fadeInUp"
                swiper-animate-duration="1s"
                src="../assets/4.jpg"
              >
              <div
                class="ani"
                swiper-animate-effect="fadeInUp"
                swiper-animate-duration="1s"
                swiper-animate-delay="0.6s"
              >
                <h4>Customs declaration & Trucking</h4>
              </div>
            </div>
            <div class="swiper-slide">
              <img
                class="ani"
                swiper-animate-effect="fadeInUp"
                swiper-animate-duration="1s"
                src="../assets/5.jpg"
              >
              <div
                class="ani"
                swiper-animate-effect="fadeInUp"
                swiper-animate-duration="1s"
                swiper-animate-delay="0.6s"
              >
                <h4>Reefer container & Cool chain</h4>
              </div>
            </div>
            <div class="swiper-slide">
              <img
                class="ani"
                swiper-animate-effect="fadeInUp"
                swiper-animate-duration="1s"
                src="../assets/6.jpg"
              >
              <div
                class="ani"
                swiper-animate-effect="fadeInUp"
                swiper-animate-duration="1s"
                swiper-animate-delay="0.6s"
              >
                <h4>OOG & Break Bulk</h4>
              </div>
            </div>
            <div class="swiper-slide">
              <img
                class="ani"
                swiper-animate-effect="fadeInUp"
                swiper-animate-duration="1s"
                src="../assets/7.jpg"
              >
              <div
                class="ani"
                swiper-animate-effect="fadeInUp"
                swiper-animate-duration="1s"
                swiper-animate-delay="0.6s"
              >
                <h4>Railway Service</h4>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>

        <div class="swiper-pagination business-pagination"></div>
      </div>
    </div>
    <div class="swiper-bg"></div>
  </div>
</template>

<script>
import Swiper from "swiper";
export default {
  name: "business",
  data() {
    return {};
  },
  components: {},
  mounted() {
    if (window.document.body.clientWidth > 992) {
      new Swiper(".business-container", {
        loop: true,
        slidesPerView: 3,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      });
    } else {
      new Swiper(".business-container", {
        loop: true,
        pagination: {
          el: ".business-pagination",
          clickable: true
        }
      });
    }
  }
};
</script>

<style>
@import "../../node_modules/swiper/dist/css/swiper.min.css";
.business-swiper {
  max-width: 1400px;
  margin: 70px auto 0;
  text-align: center;
  position: relative;
}
.business-container {
  margin: 0 50px;
  overflow: hidden;
}
.business-swiper img {
  /* width: 350px; */
  width: 80%;
}
.business-swiper .swiper-slide h4,
.business-swiper .swiper-slide p {
  color: #f4f4f4;
  text-align: left;
  max-width: 80%;
  margin: 0 auto;
}
.business-swiper .swiper-slide h4 {
  font-size: 20px;
  margin: 10px auto;
}
.business {
  position: relative;
  height: 100%;
  margin: 0 30px;
}
.business-con {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  z-index: 99;
}
.swiper-bg {
  background: #367ad8;
  position: absolute;
  bottom: 40px;
  width: 100%;
  height: 54%;
  /* z-index: -1; */
}
.swiper-button-prev,
.swiper-button-next {
  background-image: url(../assets/prev.png);
  top: 40%;
  left: -0;
  width: 45px;
  height: 45px;
  outline: none;
  z-index: 9999;
}
.swiper-button-next {
  background-image: url(../assets/next.png);
  left: auto;
  right: -0;
}
.business-title h2 {
  /* margin-top: 100px; */
  color: #333;
  padding: 40px 0 30px 0;
  font-size: 56px;
  text-align: center;
  background: url(../assets/main.png) no-repeat center;
  background-size: 400px;
}
@media screen and (max-width: 992px) {
  .business-title h2 {
    font-size: 30px;
    background-size: 52%;
    background-position: center;
    padding: 12px 0;
  }
  .business {
    margin: 0;
  }
  .business-con {
    top: 52%;
  }
  .business-swiper .swiper-slide:not(.swiper-slide-active) {
    transform: scale(0.9);
    opacity: 0.6;
  }
  .business-container .swiper-slide {
    /* transition: 0.8s; */
  }
  .swiper-button-next,
  .swiper-button-prev {
    display: none;
  }
  .business-swiper {
    width: 75%;
    margin-top: 25px;
  }
  .business-container {
    margin: 0;
    overflow: visible;
  }
  .business-container .swiper-slide img {
    width: 100%;
  }
  .swiper-bg {
    bottom: 0;
  }
  .business-swiper .swiper-slide h4 {
    text-align: center;
    margin-top: 50px;
  }
  .business-pagination {
    position: absolute;
    bottom: 76px;
    left: 50%;
    transform: translateX(-50%);
  }
  .business-pagination .swiper-pagination-bullet {
    background: #fff;
    margin: 0 2px !important;
    display: inline-block;
  }
  .business-pagination .swiper-pagination-bullet-active {
    padding: 0;
  }
}
</style>




// WEBPACK FOOTER //
// src/view/Business.vue